'use strict';
/* eslint-disable */
var ajax = require('_core_ext/ajax'),
    progress = require('_core/progress'),
    util = require('_core_ext/util'),
    imagesLoaded = require('imagesloaded'),
    layout = require('_core_ext/layout'),
    dialog = require('_core_ext/dialog');

import eventMgr from '_core_ext/core/eventMgr';
import { refreshKlarnaOSM } from '_core_ext/helpers/klarnaHelpers';
import slickSlider from '../../components/common/SlickSlider';
const emitter = eventMgr.getEmitter('productVariation');

var $cache = {},
    initialized = false,
    selectors = {
        pdpForm: '.pdpForm',
        variationDropDown: 'variation-select',
        stickyContent: '.js-product-details-sticky',
        swatchLink: '.c-product-details__info .c-product-variations__link',
        editModalSwatchLink: '.product-edit-modal .c-product-details__info .c-product-variations__link',
        productImages: '.js-product-images',
        productImagesWrapper: '.js-product-images-wrap'
    };

function initializeCache() {
    $cache = {
        document: $(document),
        pdpMain: $('#pdpMain'),
        pdpContent: $('#product-content'),
        productImageWrapper: $(selectors.productImagesWrapper),
        productImageContainer: $(selectors.productImages)
    };
}

/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 * @param {String} hrefBrowser - url of the new product variant to set in Browser
 **/
var updateContent = function (href, hrefBrowser, linkRef, editCart, isVariantSelection) {
    var $pdpForm = $cache.document.find(selectors.pdpForm);
    var qty = $pdpForm.find('input[name="Quantity"]').first().val();
    var params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
    };

    if (editCart) {
        progress.show($(linkRef).closest('.js-edit-cart'));
    } else {
        progress.show($cache.pdpMain);
    }
    ajax.load({
        url: util.appendParamsToUrl(href, params),
        callback: function (response) {
            var $content = $('<div/>').append(response);
            $cache.document.find(selectors.stickyContent).replaceWith(
                $content.find(selectors.stickyContent).remove()
            );
            if (editCart) {
                $(linkRef).closest('#product-content').html($content);
                $('.js-edit-cart').attr('data-variation-changed', 'true');
            } else {
                $cache.pdpContent.html($content);
                // Update the URL in browser
                window.history.replaceState({}, '', hrefBrowser);
            }
            $cache.document.trigger('product.variation.changed');
            emitter.emit('changed');
            refreshKlarnaOSM();
            if ($('.js-product-nav-xs .c-product-nav').length > 0) {
                $('.js-product-nav-lg .c-product-nav').html($('.js-product-nav-xs .c-product-nav').html());
            }

            if(isVariantSelection) {
                updateMainImagesSection($(linkRef).data('product-images-url'), linkRef, editCart);
               
            } else {
                progress.hide();
            }
            $('.cancelButton').on('click', function () {
                $("#dialog-container").dialog("close")
            })
            if (!editCart) {
                var updatedDescription = $('#product-content input[name="modalLevelLongDesc"]');
                var productDescription = $('.c-product-details__data #product-details-desc').find('.body-3');
                if(updatedDescription && updatedDescription.length > 0){
                    if(productDescription && productDescription.length > 0){
                        productDescription.html(updatedDescription.val());
                    }
                }
                var updatedComposition = $('#product-content input[name="modalLevelComposition"]');
                var productComposition = $('.c-product-details__data #product-details-composition').find('.body-3');
                if(updatedComposition && updatedComposition.length > 0){
                    if(productComposition && productComposition.length > 0){
                        productComposition.html(updatedComposition.val());
                    }
                }
            }
        }
    });
};

/**
 * @description update product images
 * @param {String} href - url of the new product variant
 **/
var updateMainImagesSection = function (href, linkRef, editCart) {
    var params = {
        format: 'ajax',
        editCart: editCart
    };

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        callback: function (response) {
            var $content = $('<div/>').append(response);
            if(editCart) {
                $('.product-edit-modal .js-edit-cart').find('.js-product-images').html(
                    $content
                );
                progress.hide();
            } else {
                $cache.productImageContainer.html(
                    $content
                );
            }

            imagesLoaded($cache.productImageContainer).on('done', function () {
                $cache.document.trigger('images.loaded');
                emitter.emit('imagesLoaded');
                if (!editCart){
                    var viewportWidth = $(window).width();
                    if($cache.productImageContainer.find('#pdp-images-slider').length > 0) {
                        $cache.productImageContainer.find('#pdp-images-thumbnail').html($cache.productImageContainer.find('#pdp-images-slider').html());
                    }
                    if (viewportWidth <= 991) {
                        slickSlider.slidePDPMainImage($cache.productImageContainer.find('#pdp-images-mobile-slider'), true, {infinite: true}, true);
                    } else {
                        let $pdpDesktopImgSlider = $cache.productImageContainer.find('#pdp-images-slider');
                        var $pdpDesktopImgThumb = $cache.productImageContainer.find('#pdp-images-thumbnail');
                        let params = {asNavFor: "#pdp-images-thumbnail", infinite: true};
                        slickSlider.slidePDPMainImage($pdpDesktopImgSlider, true, params);
                        params = {asNavFor: "#pdp-images-slider", arrows: false, infinite: false, slidesToShow: 9, focusOnSelect: true };
                        slickSlider.slidePDPMainImage($pdpDesktopImgThumb, false, params);
                        var slickObj = $pdpDesktopImgSlider.slick('getSlick');
                        var slideTimer;
                        $pdpDesktopImgThumb.on('mouseenter', '.slick-slide', function (e) {
                            let $currTarget = $(e.currentTarget);
                            $pdpDesktopImgThumb.find('.slick-slide').removeClass('slick-current');
                            $currTarget.addClass('slick-current');
                            slideTimer = setTimeout(function () {
                                let index = $pdpDesktopImgThumb.find('.slick-current').data('slick-index');
                                slickObj.slickGoTo(index, true);
                            }, 0);
                        }).on('mouseleave', '.slick-slide', function (e) {
                            clearTimeout(slideTimer);
                        });
                        $('#pdp-images-slider').mouseenter(function() {
                            $(this).addClass('pdp-arrows-on-hover');
                        });
                        $('#pdp-images-slider').mouseleave(function() {
                            $(this).removeClass('pdp-arrows-on-hover');
                        });
                        $('.cancelButton').on('click', function () {
                            $("#dialog-container").dialog("close")
                        })
                    }
                    var isShopTheLook = $('div.shop-the-look');
                    var hideShopTheLook = $('div.shop-the-look').hasClass('is--hidden');
                    if(isShopTheLook.length > 0 && !(hideShopTheLook)){
                        $('.shopthelook-btn').removeClass('d-none');
                    }
                }
                progress.hide();
            });
        }
    });
};

var adaptImageContainerHeight = function () {
    if (layout.isMobileView()) {
        var imageContainerHeight = Math.ceil($cache.productImageContainer.outerHeight(false)) + 'px';
        $cache.productImageWrapper.css('min-height', imageContainerHeight);
    }
}

/**
 * @description handel product edit modal quantity wrapper position
 **/
var handelProductEditModalQtyPos = function () {
    const $editModalImages = $('.product-edit-modal .c-product-details__images'),
        $editProductNumber = $('.product-edit-modal .product-number-wrap'),
        $editProductName = $('.product-edit-modal .c-product-details__name'),
        $editProductTotal = $('.product-edit-modal .c-products-item__total'),
        $editProductQuantity = $('.product-edit-modal .quantity-select');
    if (layout.isMobileView()) {
        $editProductQuantity.css('top', 
            parseInt($editModalImages.css('padding-top')) +
            parseInt($editProductNumber.outerHeight()) +
            parseInt($editProductName.outerHeight()) +
            parseInt($editProductTotal.height())
        );
        $editProductTotal.css('top', 
            parseInt($editModalImages.css('padding-top')) +
            parseInt($editProductNumber.outerHeight()) +
            parseInt($editProductName.outerHeight())
        );
    } else {
        $editProductQuantity.css('top', 
            parseInt($('.product-edit-modal .c-product-details__info').css('padding-top')) +
            parseInt($editProductName.outerHeight()) +
            parseInt($editProductTotal.height()) + 15
        );
    }
}

function initializeEvents() {
    $cache.document.on('click', selectors.swatchLink, selectors.editModalSwatchLink, function (e) {
        e.preventDefault();
        var isVariantSelection = true;
        if ($(this).parent('.c-product-variations__subitem').hasClass('selected')) {
            return false;
        }
        var editCart = false;
        if ($('#dialog-container #pdpMain').hasClass('js-edit-cart')) {
            initializeCache();
            editCart = true;
            var quantityEdit = $('#showQuantityEdit').val();
            this.href = util.appendParamsToUrl(this.href, { editItem: true, showQuantityEdit: quantityEdit });
        }
        updateContent(this.href, this.getAttribute('hrefbrowser'), this, editCart, isVariantSelection);
    });

    // change drop down variation attribute - should replace product content with new variant
    $cache.pdpMain.on('change', selectors.variationDropDown, function () {
        if ($(this).val().length === 0) { return; }
        updateContent($(this).val());
    });

    /** This fix was disabled because it did not take into account that the variations groups may have a
     * different amount of images, so when the user switches from a variation group with N images to another
     * one with  M images and N > M or N < M the height of the images container is not calculated accurately
     * TODO: This issue must be addressed when working on the PDP updates
     * */
    // $(window).on('load', adaptImageContainerHeight);

    $('#pdp-images-slider').mouseenter(function() {
        $(this).addClass('pdp-arrows-on-hover');
        
    });
    $('#pdp-images-slider').mouseleave(function() {
        $(this).removeClass('pdp-arrows-on-hover');
    });

// To open the edit cart modal on cart page
    $(document).on('click', '.c-products-item__action-edit', function(e) {
        e.preventDefault();
        var targetWrapper = $(this).parents('.c-mini-cart__product-item-action-links').length > 0 ? 'minibag' : 'cart';
        var targetPos, initialQty;
        if(targetWrapper === 'cart') {
            targetPos = $('.cart-product-wrapper .c-products-table__item').index($(this).parents('.c-products-table__item')) + 1;
            initialQty = parseInt($(this).closest('.c-products-table__item').find('.c-order-table__quantity').text());
        } else {
            targetPos = $('.c-mini-cart__wrapper .c-mini-cart__product-item-row, .c-checkout-minicart__list .c-mini-cart__product-item-row').index($(this).parents('.c-mini-cart__product-item-row')) + 1;
            initialQty = parseInt($(this).closest('.c-mini-cart__product-item-row').find('.c-mini-cart-qty span').text());
        }
        progress.show();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                dialogClass: "product-edit-modal",
                open: function () {
                    var slickSlide,
                        slidesToShow,
                        slideToScroll;
                    progress.hide();
                    handelProductEditModalQtyPos();
                    if(targetWrapper === 'minibag') {
                        $('.product-edit-modal').addClass('miniBagTriggered');
                        if($('.c-checkout-minicart__list').length > 0) {
                            $('.product-edit-modal').addClass('triggeredFromCheckout');
                        }
                    } else {
                        $('.product-edit-modal').addClass('cartTriggered');
                    }
                    $('.product-edit-modal').find('.js-edit-cart').attr('data-trigger-pos', targetPos);
                    $('.product-edit-modal').find('.js-edit-cart').attr('data-trigger-initial-qty', initialQty);
                    
                    $('.cancelButton').on('click', function () {
                        $("#dialog-container").dialog("close")
                    })
                }
            }
        });
    });

    $(window).on('resize', function () {
        handelProductEditModalQtyPos();
    });
    
    $(document).on('click','#copyButton', function () {
        const code = $('.codeid').text().trim();
        navigator.clipboard.writeText(code)
            .then(() => { 
                $('.coupon-code').addClass('d-none');
                $('.coupon-copied ').removeClass('d-none');
            })
            .catch(err => console.error('Copy failed', err));
    });
}

var variations = {
    init: function() {
        if (initialized) {
            return;
        }
        initializeCache();
        initializeEvents();
        initialized = true;
    }
};

module.exports = variations;